import React from "react";
import ActionsContextV2 from "../ActionsContextV2";
import styled from "styled-components";
import { Tabs, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const TabsContainer = styled.div`
  width: 100%;
`;

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: '61px'
  },
}));

const ActionsFunctionSelection = () => {
  const context = React.useContext(ActionsContextV2);
  const classes = useStyles();

  if (!context.actionsRedux.selectedProject) return null;

  const tabIndex = context.actionsRedux.selectedProject.selectedFunction
    ? context.actionsRedux.selectedProject.functions.findIndex(
       aFunction => aFunction.id === context.actionsRedux.selectedProject.selectedFunction.id
      )
    : undefined;

  
  return (
    <TabsContainer>
      <Tabs
        indicatorColor="primary" 
        value={tabIndex}
        variant="scrollable"
        scrollButtons="auto"
        onChange={(event,tabsValue) => {
          context.selectProjectFunction(context.actionsRedux.selectedProject.functions[tabsValue]);
          context.setCategoryFilterText('');
          context.setComplianceFilterText('');

        }}
      > 
      {context.actionsRedux.selectedProject.functions.map((aFunction) => (
        <Tab className={classes.root} label={aFunction.name} key={aFunction.id} />
      ))}
      </Tabs>
    </TabsContainer>
  );
};

export default ActionsFunctionSelection;
